import { render, staticRenderFns } from "./ReservationRacersForm.vue?vue&type=template&id=05074c9e"
import script from "./ReservationRacersForm.vue?vue&type=script&lang=js"
export * from "./ReservationRacersForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports